<h3 (click)="setCurrent()">{{ index + 1 }} - {{ widgetNotFound ? ('WIDGET_NOT_FOUND/TEXT' | translate) : widgetLayers?.chartTitle.value(language) }}</h3>